export const CITIES_STORE_FETCH_ERROR = 'Ошибка при получении городов:';
